import React from 'react'
import { IWizardStepContext, StepName } from '../types'
import { notYetImplementedWithError } from '../../../utils'
import { ComponentWithChildren } from '../../../types'

export interface PhotoStepFormData {
  photos: File[]
}

const defaultFormData = {
  photos: []
}

const PhotoStepContext = React.createContext<IWizardStepContext<PhotoStepFormData>>({
  name: StepName.Photos,
  data: defaultFormData,
  setStepData: notYetImplementedWithError,
  validateStepData: notYetImplementedWithError
})

interface PhotoStepProviderProps extends ComponentWithChildren {
  initialData?: PhotoStepFormData
}

export const PhotoStepProvider: React.FC<PhotoStepProviderProps> = ({ children, initialData }) => {
  const [data, setStepData] = React.useState<PhotoStepFormData>(initialData ?? defaultFormData)

  const value = React.useMemo<IWizardStepContext<PhotoStepFormData>>(() => {
    const validateStepData = (): void => {
      if (data.photos.length === 0) {
        throw new Error('Photos are required')
      }
    }

    return {
      name: StepName.Photos,
      data,
      setStepData,
      validateStepData
    }
  }, [data])

  return (
    <PhotoStepContext.Provider value={value}>
      {children}
    </PhotoStepContext.Provider>
  )
}

export default PhotoStepContext
